<template>
  <vue100vh style="position: fixed; width: 100%;">
  <v-app style="overflow: hidden;">
    <v-toolbar style="background-color: white !important; overflow: hidden !important;">
      <v-btn icon @click="toPage('/mobile/homepage')">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-toolbar-title>{{$t('HeaderMenubar.sendOnebox')}}</v-toolbar-title>
    </v-toolbar>
    <v-layout row wrap style="overflow: hidden !important;">
      <v-flex xs12 sm12 md12 style="margin-top: 3vh; height: 25vh;">
        <v-layout align-center justify-center column>
          <!-- <form ref="fileform" style="width: 300px; border-radius: 5px; border-style: dotted; border-color: #f5f5f5; background-color: #009aff3d; text-align: center;">
            <img src='/static/img/onechat/box.png' style="width: 45px;"/>
            <label style="text-align: center; cursor: pointer; margin-bottom: 10vh;">
              <b class="CSChatThai" style="text-decoration: underline;cursor: pointer;text-indent: 5em;">{{$t('AnswerQuestion.selectFile')}}</b>
              <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()"/>
            </label>
          </form> -->
          <div ref="fileform" style="width: 300px; border-radius: 5px; border-style: dotted; border-color: #f5f5f5; background-color: #009aff3d; text-align: center;">
            <img src='/static/img/onechat/box.png' style="margin-top: 2vh" width="45"/><br />
            <label style="text-align: center; cursor: pointer;">
              <v-btn
                style="margin-bottom: 2vh; font-weight: bold;"
                color="primary"
                small 
                @click="openFileimage"
              >
                {{$t('AnswerQuestion.selectFile')}}
              </v-btn>
              <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()"/>
            </label>
			    </div>
        </v-layout>
      </v-flex>
      <v-layout row wrap justify-center align-center>
        <v-flex xs12 sm12 md12 style="padding-top: 6vh;" class="text-xs-center text-sm-center">
          <v-btn small round outline color="primary" dark @click="submitallFiles()" v-if="files.length > 0 "> <i class="fas fa-upload" style="margin-bottom: 3px;"></i>&nbsp&nbsp{{$t('AnswerQuestion.uploadAll')}}</v-btn>
        </v-flex>
        <v-flex xs12 sm12 md12 v-if="files.length > 0 " style="overflow-x: scroll;overflow-y: hidden;height: 45vh !important; max-width: 70vw !important; display: -webkit-inline-box; padding-top: 5vh;" class="containers">
          <div class="borderfile" v-for="(file, key) in files" style="justify-content: center; margin-left: 2vw; padding-top: 1vh;">
            <a class="close-classic" @click="removeFile( key )"></a>
            <div v-if="extension(file.file.name) == 'fas fa-file-image'" style="text-align: center; display: grid; justify-content: center; padding-top: 1vh;">
              <img class="preview" v-bind:ref="'preview'+parseInt( key )" style="object-fit: cover; height: 10vh !important; width:15vh !important;display: flex;justify-content: center;" />
              <b class="text2">{{ file.file.name }}</b>
              <v-icon v-if="file.status == 'fail'" style="color: red;">fas fa-exclamation-triangle</v-icon>
                <v-icon v-else-if="file.status == 'success'" style="color: green;">fas fa-check</v-icon>
              <a v-if="file.status !== 'success' && file.status !== 'process'" style="text-align: center;" @click="submitFiles( key )">  {{$t('AnswerQuestion.upload')}}</a>
              <v-progress-circular indeterminate color="primary" v-if="file.status == 'process'"></v-progress-circular>
            </div>
            <div v-else style="text-align: center; display: grid; justify-content: center;" >
              <v-icon style="font-size: 35px !important; color: #1a222c;display: flex;justify-content: center;">{{ extension(file.file.name)}}</v-icon>
              <b class="text2">{{ file.file.name }}</b>
              <v-icon v-if="file.status == 'fail'" style="color: red;">fas fa-exclamation-triangle</v-icon>
                <v-icon v-else-if="file.status == 'success'" style="color: green;">fas fa-check</v-icon>
              <a v-if="file.status !== 'success' && file.status !== 'process'" style="text-align: center;" @click="submitFiles( key )"> {{ $t('AnswerQuestion.upload')}}</a>
              <v-progress-circular indeterminate color="primary" v-if="file.status == 'process'"></v-progress-circular>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-app>
</vue100vh>
</template>
<script>
  import { Decode } from '@/services'
  import vue100vh from 'vue-100vh'
  export default {
    data () {
      return {
        dragAndDropCapable: false,
        files: [],
        token: ''
      }
    },
    mounted () {
      this.dragAndDropCapable = this.determineDragAndDropCapable()
      if (this.dragAndDropCapable) {
        ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
          this.$refs.fileform.addEventListener(evt, function (e) {
            e.preventDefault()
            e.stopPropagation()
          })
        }.bind(this))
        this.$refs.fileform.addEventListener('drop', function (e) {
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            this.files.push({file: e.dataTransfer.files[i], status: 'waiting'})
            this.getImagePreviews()
          }
        }.bind(this))
      }
    },
    components: {
      vue100vh
    },
    methods: {
      openFileimage () {
        this.$refs.files.click()
      },
      toPage (data) {
        this.$router.push(data)
      },
      upfile () {
        $('#uploadfile').click()
      },
      determineDragAndDropCapable () {
        var div = document.createElement('div')
        return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window
      },
      getImagePreviews (key) {
        for (let i = 0; i < this.files.length; i++) {
          if (/\.(jpe?g|png|gif)$/i.test(this.files[i].file.name)) {
            let reader = new FileReader()
            reader.addEventListener('load', function () {
              this.$refs['preview' + parseInt(i)][0].src = reader.result
            }.bind(this), false)
            reader.readAsDataURL(this.files[i].file)
            // this.extension(this.files[i].name)
            // console.log(this.extension())
          } else {
            // this.$nextTick(function(){
            // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
            // });
            // console.log('mm')
          }
        }
      },
      handleFilesUpload (key) {
        let uploadedFiles = this.$refs.files.files
        for (var i = 0; i < uploadedFiles.length; i++) {
          this.files.push({file: uploadedFiles[i], status: 'waiting'})
        }
        this.getImagePreviews(key)
        document.querySelector('#files').value = ''
      },
      submitFiles (key) {
        let formData = new FormData()
        // for (var i = 0; i < this.files.length; i++) {
        let file = this.files[key].file
        formData.append('files[' + key + ']', file)
        formData.append('file', file, file.name)
        formData.append('tokenuser', this.token)
        formData.append('appkey', 'QWErty1234')
        this.axios.post(process.env.APIpub + '/save_onebox', formData).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            // console.log(response)
            this.$swal('', this.$t('Alert.Success.success'), 'success')
            // this.files.splice(key, 1)
            this.removeFile(key)
          // this.files.splice( key )
          } else {
            this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
            this.files[key]['status'] = 'fail'
          }
        }, response => {
          // console.log('error')
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
          this.files[key]['status'] = 'fail'
        }).catch((error) => {
          console.log(error)
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
          this.files[key]['status'] = 'fail'
        })
      },
      removeFile (key) {
        this.files.splice(key, 1)
        // this.getImagePreviews(key)
      },
      submitallFiles () {
        var lengthfile = this.files.length
        for (var i = 0; i < lengthfile; i++) {
          this.senbox(i)
        }
      },
      senbox (i) {
        let formData = new FormData()
        var file = this.files[i].file
        // formData.append('files[0]', file)
        formData.append('file', file, file.name)
        formData.append('tokenuser', this.token)
        this.files[i]['status'] = 'process'
        this.axios.post(process.env.APIpub + '/save_onebox', formData).then((response) => {
          if (response.data.status === 'success') {
            // console.log('success')
            this.files[i]['status'] = 'success'
            // this.removeFile(i)
            // console.log(this.files.length)
            // return 'true'
            // console.log(this.files.length)
          } else {
            this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
            this.files[i]['status'] = 'fail'
            // return 'false'
          }
        }).catch((error) => {
          console.log(error)
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
          this.files[i]['status'] = 'fail'
        })
      },
      extension (files) {
        var extension = files.split('.')[files.split('.').length - 1].toLowerCase()
        var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
        var pdf = ['pdf']
        var file = ['ai', 'ps', 'psd']
        var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
        var presentation = ['ppt', 'pps', 'pot', 'pptx']
        var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
        var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
        var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff']
        if (pdf.includes(extension)) {
          return 'fas fa-file-pdf'
        } else if (archive.includes(extension)) {
          return 'fas fa-file-archive'
        } else if (spreadsheet.includes(extension)) {
          return 'fas fa-file-excel'
        } else if (presentation.includes(extension)) {
          return 'fas fa-file-powerpoint'
        } else if (word.includes(extension)) {
          return 'fas fa-file-word'
        } else if (execution.includes(extension)) {
          return 'fas fa-file-code'
        } else if (image.includes(extension)) {
          return 'fas fa-file-image'
        } else if (file.includes(extension)) {
          return 'fas fa-file'
        } else {
          return 'fas fa-file-alt'
        }
      // return extension[extension.length-1]
      }
    },
    created () {
      var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
      this.token = decoded['tokenuser']
    // console.log(this.token)
    }
  }
</script>
<style scoped>
>>>.v-toolbar {
  /* box-shadow: none; */
  box-shadow: 0 2px 0px -1px hsla(0,0%,100%,.12), 0 0px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12) !important;
}
.text2 {
  white-space: nowrap;
  width: 15vh;
  overflow: hidden;
  text-overflow: ellipsis;
}
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}
  form{
    display: block;
    height: 60px;
    width: 190px;
    background: #2196f336;
    /*background: 'http://www.clker.com/cliparts/r/i/S/H/R/s/open-box-hi.png';*/
    /*margin: auto;*/
    /*margin-top: 40px;*/
    text-align: center;
    line-height: 95px;
    border-radius: 4px;
    /*border-style: dotted;*/
    border-color: #1a222c;
  }

  div.file-listing{
    width: 400px;
    margin: auto;
    padding: 10px;
    border-bottom: 1px solid #ddd;
  }

  div.file-listing img{
    height: 100px;
  }

  div.remove-container{
    text-align: center;
  }

  div.remove-container a{
    color: red;
    cursor: pointer;
  }

  a.submit-button{
    display: block;
    margin: auto;
    text-align: center;
    width: 200px;
    padding: 10px;
    text-transform: uppercase;
    background-color: #CCC;
    color: white;
    font-weight: bold;
    margin-top: 20px;
  }

  progress{
    width: 400px;
    margin: auto;
    display: block;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  input[type="file"]{
    position: absolute;
    top: -500px;
  }
  div.file-listing img{
    max-width: 90%;
  }
  .borderfile {
    border: 1px solid #00000036;
    border-radius: 5px;
    width: 35vw !important;
    height: 24vh !important;
    position: relative;
    background: white;
}
.containers {
  width: 576px; margin: 0 auto;
}

.containers:after {
  content: '';
  display: block;
  clear: both;
}

[class*='close-'] {
  color: #777;
  font: 14px/100% arial, sans-serif;
  position: absolute;
  right: 5px;
  text-decoration: none;
  text-shadow: 0 1px 0 #fff;
  top: 5px;
}
.close-classic:after {
  content: '×'; /* ANSI X letter */
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/settings/Sendfileonebox.vue